module.exports = {

  MIN_USER_PASSWORD_LENGTH: 8

};
